import { render, staticRenderFns } from "./Mentionable.vue?vue&type=template&id=27f94584&"
import script from "./Mentionable.vue?vue&type=script&lang=js&"
export * from "./Mentionable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports